import ReactDOM from 'react-dom';
import React from 'react';
import { Router } from 'react-router';
import ReduxToastr from 'react-redux-toastr';
import { bindActionCreators } from 'redux';
import store from 'router/store';
import history from 'router/history';
import setupAxiosInterceptors from 'rest/axios';
import { logout, redirectToLoginWithMessage } from 'actions/authentication';
import getRoutes from 'router/Credit24/LoanApplication/router.au-increase';
import Provider from 'containers/common/Provider';

if (!global.Intl) {
  /* eslint-disable */
  global.Intl = require('intl');
  require('intl/locale-data/jsonp/en.js');
  /* eslint-enable */
}

const actions = bindActionCreators({ redirectToLoginWithMessage, logout }, store.dispatch);
setupAxiosInterceptors(() => actions.redirectToLoginWithMessage('login.session.expired'));

ReactDOM.render(
  <Provider store={store}>
    <div>
      <ReduxToastr
        timeOut={5000}
        newestOnTop
        position="top-right"
      />
      <Router history={history} routes={getRoutes()} />
    </div>
  </Provider>,
  document.getElementById('app')
);
